import {
  AccentColorProvider,
  EditorModeProvider,
  ThemeProvider,
} from "@cheatsheetz/core-ui";
import { SessionProvider } from "@cheatsheetz/sheetz-accounts/providers/Session/SessionProvider";
import { SettingsSync } from "@cheatsheetz/sheetz-accounts/providers/SettingsSync";
import {
  type AuthConfig,
  AuthProvider,
} from "@cheatsheetz/sheetz-core/providers/AuthProvider";
import { CheatsheetzFetchProvider } from "@cheatsheetz/sheetz-core/providers/CheatsheetzFetchProvider";
import { RouterProvider } from "react-router-dom";
import { QueryProvider } from "@/providers/QueryProvider";
import { router } from "@/router";

// OIDC configuration for the IDP
const authConfig: AuthConfig = {
  // In dev, /id is proxied to the IDP backend at localhost:5002
  // In prod, /id is routed by nginx to the IDP
  authority: `${window.location.origin}/id`,
  clientId: "cheatsheetz-spa",
  redirectUri: `${window.location.origin}/auth/callback`,
  postLogoutRedirectUri: window.location.origin,
  scope: "openid profile email offline_access cheatsheetz-api",
};

export function App() {
  return (
    <ThemeProvider>
      <AccentColorProvider>
        <EditorModeProvider>
          <QueryProvider>
            <AuthProvider config={authConfig}>
              <CheatsheetzFetchProvider>
                <SessionProvider>
                  <SettingsSync />
                  <RouterProvider router={router} />
                </SessionProvider>
              </CheatsheetzFetchProvider>
            </AuthProvider>
          </QueryProvider>
        </EditorModeProvider>
      </AccentColorProvider>
    </ThemeProvider>
  );
}
